import { render, staticRenderFns } from "./approveDialog.vue?vue&type=template&id=01c31626&scoped=true&"
import script from "./approveDialog.vue?vue&type=script&lang=ts&"
export * from "./approveDialog.vue?vue&type=script&lang=ts&"
import style0 from "./approveDialog.vue?vue&type=style&index=0&id=01c31626&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c31626",
  null
  
)

export default component.exports